import React from 'react';
import "./Footer.css";

import { GrInstagram,
         GrGithub,
         GrLinkedinOption} from 'react-icons/gr';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">Ewerton Lopes</h1>

                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Portfolio</a>
                    </li>

                    <li>
                        <a href="#services" className="footer__link">Services</a>
                    </li>
                </ul>

                <div className="footer__social">
                <a href="https://www.linkedin.com/in/ewerton-lopes-pereira/" className="footer__social-link" target="_blank" rel="noreferrer">
                        <GrLinkedinOption />
                    </a>
                    <a href="https://www.instagram.com/ewerton_lp" className="footer__social-link" target="_blank" rel="noreferrer">
                        <GrInstagram />
                    </a>
                    <a href="https://www.github.com/ewertonlp" className="footer__social-link" target="_blank" rel="noreferrer">
                        <GrGithub />
                    </a>
                    
                </div>

                <span className='footer__copy'>&#169; 2025. Ewerton Lopes Pereira. All rigths reserved</span>
            </div>
        </footer>
    )
}

export default Footer;